import React from "react";
import { Select } from "../../../../../../shared/infrastructure/ui";
import { SelectComponentProps } from "./types";
import { useInfiniteGetZip3Markets } from "../../../services";
import { withSelectOptions } from "./with-select-options";
import {
  UseGetZip3MarketsFilters,
  Zip3MarketsT,
} from "../../../../domain/entities";

const RenderOption = ({
  zip3,
  market,
  market_name,
  city,
  state_id,
  state_code,
}: Zip3MarketsT): React.ReactElement => {
  return market ? (
    <section className="grid w-[250px] grid-flow-col items-center justify-between gap-[10px] px-[5px] text-[12px]">
      <span className="overflow-hidden text-ellipsis whitespace-nowrap">
        {market ?? "- -"}
      </span>
      <span className="overflow-hidden text-ellipsis whitespace-nowrap">
        {market_name ?? "- -"}
      </span>
      <span className="rounded-[5px] bg-[#F4F4F4] py-[5px] px-[10px] text-[10px]">
        {zip3 ?? "- -"}
      </span>
    </section>
  ) : (
    <section className="grid w-[300px] grid-flow-col items-center justify-between px-[5px] text-[12px]">
      <span>
        {city}, {state_code ?? state_id}
      </span>
    </section>
  );
};

const LocationMarketSelectComponent = ({
  placeholder,
  name = "",
  selectedValue,
  onChangeValue,
  error = "",
  variant = "standard",
  disabled = false,
  handleSetKeyword,
  isLoading,
  getNextPage,
  noMore,
  data,
  noError,
  labelProp = "market",
  keyword,
  multiselect,
  required,
}: SelectComponentProps<Zip3MarketsT>): React.ReactElement => {
  return (
    <Select<Zip3MarketsT>
      searchValue={keyword}
      multiselect={multiselect}
      disabled={disabled}
      loading={isLoading}
      placeholder={placeholder}
      options={data}
      name={name}
      asyncFilter={handleSetKeyword}
      labelProp={labelProp}
      value={selectedValue}
      onChange={onChangeValue}
      noMore={noMore}
      getMore={getNextPage}
      renderOptionComponent={RenderOption}
      error={error}
      variant={variant}
      noError={noError}
      required={required}
    />
  );
};

export const LocationMarketsSelect = withSelectOptions<
  Zip3MarketsT,
  UseGetZip3MarketsFilters
>(LocationMarketSelectComponent, useInfiniteGetZip3Markets, "zip_market");
